import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import Icon from "../../common/icon/icon.component"
import { InventoryMovementStatusProps } from "../../common/types/inventory"
import { INVENTORY_STOCK_DIRECTION } from "../../utils/inventory"
import { useSelector } from "react-redux"
import { StockDocumentSelector } from "../../state/inventory/stockdocument/selectors"
import ClipSpinner from "../../common/spinner/ClipSpinner"

const InventoryMovementStatus = (props: InventoryMovementStatusProps) => {
    const isFetching = useSelector(StockDocumentSelector.isFetching)

    let className = "badge badge-pill badge-warning"
    let spinnerColor = "#000000"
    if (props.item?.attributes.measure == props.item?.attributes.inventorySentMeasure ||
        props.item?.attributes.measure == props.item?.attributes.inventoryReceivedMeasure) {
        className = "badge badge-pill badge-success"
        spinnerColor = "#FFFFFF"
    }

    const message = props.direction == INVENTORY_STOCK_DIRECTION.OUT ?
        <FormattedMessage
            id="pricing.components.item_movement_status.sent"
            defaultMessage="Sent"
        /> :
        <FormattedMessage
            id="pricing.components.item_movement_status.received"
            defaultMessage="Received"
        />

    const total = props.item?.attributes.measure
    const movedQuantity = props.direction == INVENTORY_STOCK_DIRECTION.OUT ?
        props.item?.attributes.inventorySentMeasure :
        props.item?.attributes.inventoryReceivedMeasure

    return (
        <div className={"mb-1"}>
            {props.item && Number(props.item.attributes.measure) >= 0 &&
                <div className={className}>
                    {!isFetching ?
                        <div className="d-flex align-items-center">
                            <Icon value={"boxes"} className={"px-1"}/>
                            {message}&nbsp;{movedQuantity}/{total}
                        </div>
                        :
                        <div className="d-flex align-items-center">
                            <Icon value={"boxes"} className={"px-1"}/>
                            {message}&nbsp;
                            <ClipSpinner color={spinnerColor} height="13px" width="13px" size={10}/>
                            / {total}
                        </div>
                    }
                </div>
            }
        </div>
    )

}


export default injectIntl(InventoryMovementStatus)


// WEBPACK FOOTER //
// ./src/pricing/components/ItemMovementStatus.tsx